export const REPORT_SELECTED_FILTERS_DYNAMIC_PROP = 'selectedFilters';
export const REPORT_SORTING_DYNAMIC_PROP = 'sorting';
